import { render, staticRenderFns } from "./report-transfer.vue?vue&type=template&id=0ba71916&"
import script from "./report-transfer.vue?vue&type=script&lang=ts&"
export * from "./report-transfer.vue?vue&type=script&lang=ts&"
import style0 from "./report-transfer.vue?vue&type=style&index=0&id=0ba71916&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports